import React from "react";

const logoutContext = React.createContext(()=>{})

export default logoutContext